<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Especificações</h1>
    <div class="mb-6 flex justify-between items-center">
      <text-input v-model="form.search" class="w-full max-w-md mr-4" label="Especificação" />
      <inertia-link class="btn-indigo" :href="route('especificacoes.create')">
        <span>Criar</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Descricão</th>
          <th class="px-6 pt-6 pb-4">Atenção</th>
        </tr>

        <tr v-for="especificacao in especificacoes.data" :key="especificacao.idEspecificacao" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4 flex items-center focus:text-indigo-500">
            {{ especificacao.descricao }}
          </td>
          <td class="border-t ">
            {{ atencao(especificacao) }}
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('especificacoes.edit', especificacao.idEspecificacao)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="especificacoes.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nenhuma especificação encontrado.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="especificacoes.links" :query="filters" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import debounce from 'lodash/debounce'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import TextInput from '../../Shared/TextInput.vue'
export default {
  metaInfo: { title: 'Especificações' },
  components: {
    Icon,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    especificacoes: Object,
  },
  data() {
    return {
      options: [],
      selectedCidade:'',
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        cidade: this.filters.cidade,
        ultimoAcesso: this.filters.ultimoAcesso,
        searchCidade: this.filters.searchCidade,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: debounce(function() {
        this.$inertia.get(this.route('especificacoes'), pickBy(this.form), { preserveState: true })
      }, 500),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    onSearch(search) {
      if(search.length) {
        this.form.searchCidade=search
      }
    },
    atencao(model){
      const atencao = []
      if(model.desenvolvimento == 'S'){
        atencao.push('Desenvolvimento')
      }
      if(model.comercial == 'S'){
        atencao.push('Comercial')
      }
      if(model.implantacao == 'S'){
        atencao.push('Implantação')
      }
      return atencao.join(', ')
    },
  },


}
</script>
